import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';

import { CompanyDomain } from 'src/app/modules/auth/models/CompanyDomain';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';

@Component({
  selector: 'app-custom-spinner',
  standalone: true,
  imports: [AsyncPipe],
  template: `
    @if (loadingService.isLoading$ | async) {
      <div
        class="overlay-spinner d-flex justify-content-center align-items-center"
      >
        <img
          [src]="companyDetails?.companyLoaderGif || 'assets/images/app-loader.gif'"
          style="max-width: 100px; height: auto"
          alt=""
        />
      </div>
    }
  `,
  styleUrls: ['./custom-spinner.component.scss'],
})
export class CustomSpinnerComponent {
  private readonly authService = inject(AuthService);
  readonly loadingService = inject(LoadingService);

  get companyDetails(): CompanyDomain | undefined {
    return this.authService.companydetails;
  }
}
